// extracted by mini-css-extract-plugin
export var redoItem = "_i2-1";
export var redoTrigger = "_i2-0";